import React, { useCallback, useState, useContext, useEffect } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import { useMessage } from '../components/Message';
import MessageError from '../../../../_metronic/i18n/messages/pt.json';
import GoogleLogin from 'react-google-login';
import { Preloader, Bars } from 'react-preloader-icon';
import TagManager from 'react-gtm-module';
import Button from '../../../components/Button';
import ThemeContext from '../../../context/theme';
import * as auth from "../../../store/ducks/auth.duck";
import { login, loginGoogle, resendEmail } from "../../../crud/auth.crud";
import { isValidLogin } from '../../../utils/validators/isValidYup';
import useGetWindowWidth from '../../../utils/useGetWindowWidth';
import logoGoogle from '../../../assets/icons/icon_google.svg';
import logoDevariaDark from '../../../assets/logo/logo-devaria-02.svg'
import windowSize from '../../../constants/WindowSize';
import { CMSService } from '../../../../app/services';
import Header from '../components/Header';
import Input from '../components/Input';
import Footer from '../components/Footer';

import {
  Container,
  Body,
  ContainerInputs,
  ContainerForgotPassword,
  ContainerLoginGoogle,
  ContainerRegister,
  ContainerRight,
  ContainerLeft,
  Hr,
  ContainerWithIcon,
} from './styles';
import { addFavoritesModules, addFavoritesTraining, saveBuyProduct } from '../../../utils/addFavoritesTrainingModules';
import { getChannelId } from '../../../utils/getChannelId';
import { EnefApiService } from '../../../services/EnefApiService';
import { useQuery } from '../../../utils/useQuery';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGoogle, setIsLoadingGoogle] = useState(false);
  const [isErrorNotActive, setIsErrorNotActive] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [messageError, setMessageError] = useState('');
  const { Message, handleShowError } = useMessage(6);
  const { user, authData } = useSelector((state) => state.auth);
  const { themeSelect } = useContext(ThemeContext);
  const width = useGetWindowWidth();
  const token = window.location.search.replace('?t=', '');
  const [imageLogoB2b, setImageLogoB2b] = useState('');
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();

  const { type, redirectId, buy } = useParams();

  const comprar = buy === 'buy';
  const treinamentos = type === 'treinamentos';
  const modulos = type === 'modulos';
  const turma = {
    turmaId: Number(query.get("turmaId")),
    pacote: query.get('pacote')?.toUpperCase()
  };

  const urlQuizzFreemium = process.env.REACT_APP_QUIZZ_FREMIUM_URL;

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: isValidLogin,
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values);
      setSubmitting(false);
    },
  })

  const redirectionPage = (rota) => {
    // history.push(rota);
    window.location.href = rota;
  }

  const resendEmailConfirm = async () => {
    try {
      await resendEmail(formik.values.email);
      setMessageError("Email enviado com sucesso!")
      setIsErrorNotActive(false)
      setSucess(true)
    } catch (error) {
      setIsErrorNotActive(false)
      setMessageError(
        error?.response?.data?.detail
        || "Erro ao enviar email");
      setSucess(false)
    }
    handleShowError();
  }

  const activeAccount = useCallback(async () => {
    try {
      const api = new EnefApiService();
      await api.makeHttpRequest({
        url: '/requisicaotemporaria',
        method: 'POST',
        data: {token},
      })

      const tagManagerArgs = {
        gtmId: process.env.REACT_APP_GTM_ID ? process.env.REACT_APP_GTM_ID : ''
      };

      TagManager.initialize(tagManagerArgs);
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  const addToFavorites = useCallback(async () => {
    let res = null;

    if(comprar && treinamentos)
      redirectionPage(`/treinamentos/${redirectId}`);

    else if(turma.turmaId > 0)
      redirectionPage(`/checkout?turmaId=${turma.turmaId}&pacote=${turma.pacote}`);

    else if (treinamentos)
      res = await addFavoritesTraining({ TreinamentoId: redirectId });

    else if (modulos)
      res = await addFavoritesModules({ CategoriaId: redirectId });

    if(res)
      redirectionPage(`/assistir/${type}/${redirectId}`);

  }, [history, type, redirectId, buy]);

  useEffect(() => {
    if (type && redirectId && buy && token)
      activeAccount();

    if (!!authData &&
        !!authData.token &&
        !!user &&
        !!user.perfil &&
        !!user.perfil.nome) {

      const data = {
        type: type || null,
        redirectId: redirectId || null
      }
      const isAdmin = user?.perfil?.nome === 'ADMIN';
      const isUsuario = user?.perfil?.nome === 'USER';
      const isEmpresa = user?.perfil?.nome === 'COMPANY';
      const isVerzel = user?.perfil?.nome === 'VERZEL';
      const isMais1Code = user?.perfil?.nome === 'MAIS1CODE';
      const toCheckoutPage = treinamentos && redirectId && buy;
      const toCheckoutPageBuyTreinamento = turma.turmaId > 0;
      const addCurso = type && redirectId && !buy;
      const userComTurma = user?.subClassId || user?.classId;

      saveBuyProduct(data);

      if(isEmpresa || isVerzel || isMais1Code)
        redirectionPage('/perfil');

      else if(isAdmin)
        redirectionPage('/admin/dashboard');

      else if(isUsuario){
        if(toCheckoutPage)
          redirectionPage('/checkout');

        else if(toCheckoutPageBuyTreinamento)
          redirectionPage(`/checkout?turmaId=${turma.turmaId}&pacote=${turma.pacote}`);

        else if(addCurso)
          addToFavorites();

        else if(userComTurma && !addCurso && !toCheckoutPageBuyTreinamento && !toCheckoutPage)
            redirectionPage('/perfil');
        else
            redirectionPage('/');
      }

      else
        if(type && redirectId)
          addToFavorites();
    }
    setIsLoading(false);
  }, [user, authData]);

  const checkResendConfirmationCode = async (code, email) => {
    if (code === "authentication-0003")
    {
      const api = new EnefApiService();
      const res = await api.makeHttpRequest({
        url: '/usuario/confirm-code/resend',
        method: 'POST',
        data: { email },
      });
      redirectionPage(`/confirm-code/${res.id}`);
    }
  }

  const handleSubmit = useCallback(async (values) => {
    try {
      setIsLoading(true);
      const authData = await login(values.email, values.password, buy ? true : false);
      if(!authData) {
        throw new Error('Usuário ou senha inválidos');
      }

      dispatch({
        type: auth.actionTypes.Login,
        payload: { authData }
      });
      setIsLoading(false);
      setIsErrorNotActive(false);
      setSucess(true);

    } catch (error) {
      setSucess(false)
      if (error?.response || error.message) {
        if (error?.response?.data?.detail !== "Usuário inativado"){
          await checkResendConfirmationCode(error.response.data.error, values.email);
          setIsErrorNotActive(error?.response?.data?.showResendLink)
        }

        if (typeof error.response?.data === 'string') {
          setMessageError(error.response?.data);
        } else {
          setMessageError(
            error?.response?.data?.detail
            || error.message
            || MessageError["AUTH.VALIDATION.INVALID_LOGIN"]);
        }
      }

      handleShowError();
      setIsLoading(false);
      return 0;
    };
  }, [login, dispatch]);

  const responseGoogle = useCallback(async (response) => {
    setIsLoadingGoogle(true);

    try {
      const { email, name } = response?.profileObj;
      const data = await loginGoogle(email);

      if (!data) {
        redirectionPage(`/cadastro/${name}/${email}`);
        setIsLoadingGoogle(false);
        return;
      };
      dispatch({
        type: auth.actionTypes.Login,
        payload: { authData: data }
      })
      setIsLoadingGoogle(false);
    } catch (error) {
      const { email } = response?.profileObj;
        if (error?.response?.data?.detail !== "Usuário inativado"){
          await checkResendConfirmationCode(error.response.data.error, email)
        }
      const message = error?.response?.data?.detail || error?.message || 'Erro interno, tente mais tarde'
      setFailedGoogle(message);
    }

  }, [loginGoogle]);

  const setFailedGoogle = useCallback((message) => {
    setMessageError(message)
    handleShowError();
    setIsLoadingGoogle(false);
  }, []);

  const responseGoogleFailure = useCallback((response) => {
    setMessageError('Erro ao tentar entrar com o Google, tente mais tarde.' + (
      response?.details ? `Detalhe: ${response?.details}` : ''
    ));
    handleShowError();
    setIsLoadingGoogle(false);
  }, []);

  const loadFromCMS = useCallback(async () => {
    try {
      const [imageLogoB2b] = await Promise.all([
        CMSService.getContentFromYear(themeSelect.title === 'dark' ? 'logo-light' : 'logo-dark', 'slug,title,metadata')
      ]);

      const logourl = imageLogoB2b?.metadata?.logo?.url;

      setImageLogoB2b(logourl);
    } catch (e) {
      console.error(e);
    }
  }, [imageLogoB2b, themeSelect])

  useEffect(() => {
    loadFromCMS()
  }, [themeSelect])

  return (
    <>
      <Container>
        <Header
          hasPadding={true}
          showIconTheme={false}
        />
        <Body width={width}>
          {width >= windowSize.SM &&
            <ContainerLeft width={width}>
              <Link to="/">
                <img
                  alt="logo Devaria"
                  src={logoDevariaDark}
                  style={{ height: 52 }} />
              </Link>
              {(turma.turmaId === 0 && !buy && !type)
                ? <h1>Faça<br />seu login</h1>
                : <h1 style={{fontSize: 32}}>Para prosseguir com à sua inscrição, faça seu login ou <br/>cadastro-se!</h1>
              }
              <Hr />
            </ContainerLeft>}

          <ContainerWithIcon>
            <ContainerRight width={width}>

              <ContainerLoginGoogle>
                <GoogleLogin
                  clientId={process.env.REACT_APP_KEY_API_GOOGLE_LOGIN}
                  scope={'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'}
                  render={renderProps => (
                    <>
                      {/* <ModalConfirmeGoogle
                        open={openModalConfirmeGoogle}
                        handleClose={() => setOpenModalConfirmeGoogle(false)}
                        openGoogle={renderProps.onClick}
                      /> */}
                      <button
                        // onClick={() => setOpenModalConfirmeGoogle(true)}
                        onClick={() => renderProps.onClick()}
                        style={isLoadingGoogle ? { justifyContent: 'center' } : { justifyContent: 'flex-start'}}
                        className="btn-google">
                        {isLoadingGoogle ?
                          <Preloader
                            use={Bars}
                            size={30}
                            strokeWidth={8}
                            strokeColor={themeSelect.colors.primary}
                            duration={1000}
                          />
                          :
                          <>
                            <img alt="logo" src={logoGoogle} />
                            Login com o Google
                          </>
                        }
                      </button>
                    </>
                  )}
                  // buttonText="Login"
                  onSuccess={responseGoogle}
                  onFailure={responseGoogleFailure}
                // cookiePolicy='single_host_origin'
                />

                <div className="row align-items-center">
                  <hr />
                  <span> Ou entre com </span>
                  <hr />
                </div>
              </ContainerLoginGoogle>

              <ContainerInputs >
                <form onSubmit={formik.handleSubmit}>
                  <Message message={messageError}
                    linkLabel={isErrorNotActive ? "clique aqui" : null}
                    linkOnClick={isErrorNotActive ? () => resendEmailConfirm() : null}
                    type={sucess ? 'sucess' : 'error'} />
                  <Input
                    placeholder='E-mail'
                    type='text'
                    icon='mail'
                    name='email'
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    isError={!!formik.touched?.email && !!formik.errors?.email}
                    messageError={formik.errors?.email}
                  />
                  <Input
                    placeholder='Senha'
                    type='password'
                    icon='password'
                    name='password'
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    isError={!!formik.touched?.password && !!formik.errors?.password}
                    messageError={formik.errors?.password}
                  />

                  <Button
                    type='submit'
                    loading={isLoading}
                    text='Entrar'
                    login={true}
                    opacity={(!formik.values?.email ||
                      !formik.values?.password) && 0.5}

                    cursor={(!formik.values?.email) && "not-allowed"}

                    disabled={(!formik.values?.password ||
                      !formik.values?.email) && true}
                  />
                </form>
              </ContainerInputs>

              <ContainerForgotPassword width={width}>
                <Link to="/esqueci-senha">
                  Esqueceu sua senha?
                </Link>
              </ContainerForgotPassword>

              <ContainerRegister width={width}>
                <span>Ainda não tem uma conta? </span>
                <a href={`${
                  turma.turmaId > 0
                  ? `/cadastro?turmaId=${turma.turmaId}&pacote=${turma.pacote}`
                  : type && redirectId && buy
                    ? `/cadastro/${type}/${redirectId}/${buy}`
                    : type && redirectId
                      ? `/cadastro/${type}/${redirectId}`
                      : urlQuizzFreemium}`}> Cadastre-se!</a>
              </ContainerRegister>

            </ContainerRight>
          </ContainerWithIcon>
        </Body>
        <Footer />
      </Container>
    </>
  )
}

export default Login;
